import sanityClient from '@sanity/client';

export default sanityClient({
  projectId: '3v3ax2g1',
  dataset: 'production',
  apiVersion: '2022-05-18',
  useCdn: true,
});
